import "./App.css";
import { Box, Container, Grid } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import NavBottom from "./components/NavBottom";
import Header from "./components/Header";
import Footer from "./components/Footer";

const theme = createTheme({
  palette: {
    mode: "dark",
  },

  typography: {
    fontFamily: "Rubik",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 3,
          }}
        >
          <Container maxWidth="md">
            <Outlet />
          </Container>
        </Box>

        <Footer />
        <NavBottom />
      </Grid>
    </ThemeProvider>
  );
}

export default App;
